<template>
  <div
    class="group upload-container flex flex-col gap-4 py-20 px-2 mx-[12%] bg-[#F1F5FA] dark:bg-accent 2xl:my-30"
    :class="{ 'is-dragover': dragover }"
    @click="handleClick"
    @drop.prevent="handleDrop"
    @dragover.prevent="handleDropOver"
    @dragleave.prevent="handleDropLeave"
  >
    <input ref="file" class="absolute opacity-0 h-0" :accept="accept" type="file" :multiple="multiple" @click.stop @change="handleChange" />
    <SvgIcon name="upload" class="upload block m-auto font-bold text-[90px] fill-[#0082ff]! group-hover:animate-skip"></SvgIcon>
    <div class="font-medium text-2xl text-center">
      拖动文件到这里
      <div class="text-base font-black opacity-[.6] font-[fangsong] mt-2">或者点击上传</div>
      <div class="mt-6 text-sm -mb-8 opacity-25">⭐{{ tips }}⭐</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import NProgress from 'nprogress';
import type { UploadFile, UploadRawFile } from '~/types/upload';

const emit = defineEmits(['handleChange']);

const props = defineProps({
  multiple: {
    type: Boolean,
    default: false,
  },
  accept: {
    type: String,
    default: 'image/png,image/jpeg,image/jpg',
  },
  tips: {
    type: String,
    default: '文件还未上传哦~',
  },
});
const dragover = ref(false);
const uploadFile = defineModel<UploadFile | UploadFile[]>('uploadFile');

const file = ref();

const handleClick = () => {
  file.value.value = '';
  file.value.click();
};

const handleDrop = (e: DragEvent) => {
  dragover.value = false;
  e.stopPropagation();
  const files = e.dataTransfer?.files;
  if (!files) return;
  check(files!);
};

const handleDropOver = (_e: DragEvent) => {
  dragover.value = true;
  console.log(dragover.value);
};

const handleDropLeave = (_e: DragEvent) => {
  dragover.value = false;
};

const handleChange = (e: Event) => {
  const files = (e.target as HTMLInputElement).files;
  if (!files) return;
  check(files!);
};

const check = (files: FileList) => {
  if (!files) return;
  NProgress.start();
  const uploadFiles: UploadFile[] = [];
  for (let i = 0; i < files.length; i++) {
    const file = files[i] as UploadRawFile;
    file.uid = Date.now();
    const uFile: UploadFile = {
      name: file.name,
      percentage: 0,
      status: 'ready',
      size: file.size,
      raw: file,
      uid: file.uid,
      url: URL.createObjectURL(file),
    };
    uploadFiles.push(uFile);
    const type = file.type;
    let isTypeCorrect = false;
    const types = props.accept.split(',');
    for (const t of types) {
      if (type === t) {
        isTypeCorrect = true;
        break;
      }
    }
    if (!isTypeCorrect) {
      const typeStr = types
        .map((t) => t.split('/')[1])
        .join('/')
        .toLowerCase();
      toast.warning(`上传文件格式应为${typeStr}`, {
        position: 'top-center',
        closeButton: false,
      });
      NProgress.done();
      return false;
    }
  }
  uploadFile.value = props.multiple ? uploadFiles : uploadFiles[0];
  emit('handleChange');
  NProgress.done();

  return true;
};
</script>
<style lang="scss" scoped>
.upload-container {
  border-radius: 16px;
  line-height: 2.25rem;

  box-shadow:
    4px 4px 4px #e3e3e3,
    4px -4px 4px #e3e3e3,
    -4px 4px 4px #e3e3e3,
    -4px -4px 4px #e3e3e3;
  // box-shadow: 0 3px 6px 0 rgba(0, 0, 0, .14);
  // border: 2px dashed var(--primary);

  &:hover {
    transition: 0.4s;
    box-shadow:
      0 0 0 5px #fff,
      0 0 0 8px var(--color-primary);
  }
}

.is-dragover {
  background-color: rgba($color: #5bbce8, $alpha: 0.2);
  .upload {
    animation: skip 0.5s;
  }
}
</style>
